import script from "./VoiceCardAuto.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceCardAuto.vue?vue&type=script&setup=true&lang=js"

import "./VoiceCardAuto.vue?vue&type=style&index=0&id=64351930&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64351930"]])

export default __exports__